import React, { useCallback, useEffect, useState } from 'react';

import { downloadExcel, downloadSettingExcel } from "src/utils/blob/blobUtil";

import { defaultSAL6020_R01Filter, SAL6020_R01Filter, useSAL6020_R01Store } from 'src/containers/mes/SAL/SAL6020_R01/Store_SAL6020_R01';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import { Tab } from 'src/store/useUiuxStore';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { showError, showSuccess, ShowSuccessFetch, showWarning } from 'src/utils/toast/toastUtil';

import { deleteSAL6020_R01, downloadExcel_SAL6020_R01, getSAL6020_R01AllCount, getSAL6020_R01DetailList, getSAL6020_R01List, getPdfBlob_SAL6020_R01, patchSAL6020_R01, postSAL6020_R01 } from "./Api_SAL6020_R01";
import { defaultSAL6020_R01DetailDto, defaultSAL6020_R01Dto, SAL6020_R01DetailDto, SAL6020_R01Dto, SAL6020_R01HeaderDto } from './Dto_SAL6020_R01';
import { AgGridReact } from 'ag-grid-react';
import { fetchDataSetHandler, fetchFilterConfig, gridRefSelectedRowHandler } from 'src/utils/grid/GridHandlerContent';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { useQzPrint } from 'src/hooks/useQzPrint';
import qz from 'qz-tray';

interface Props {
	gridRef: React.RefObject<AgGridReact<SAL6020_R01HeaderDto> | null>;
	detailGridRef: React.RefObject<AgGridReact<SAL6020_R01DetailDto> | null>;

	tabList: Tab[] | undefined;
	setMessage: (message: string) => void;

	containerRef: React.RefObject<HTMLDivElement | null>;
	isResizing: React.MutableRefObject<boolean>;
	
}

export const Content_SAL6020_R01 = (props: Props) => {

	const {
		gridRef, detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
	} = props;


	const [ detailFetchTrigger, setDetailFetchTrigger] = useState(false);

	
	const {
		SAL6020_R01Filter, setSAL6020_R01Filter,
		SAL6020_R01PastFilter, setSAL6020_R01PastFilter,
		SAL6020_R01List, setSAL6020_R01List,
		editSAL6020_R01, setEditSAL6020_R01,
		selectedSAL6020_R01, setSelectedSAL6020_R01, 
		deletedSAL6020_R01DetailList, setDeletedSAL6020_R01DetailList, addDeletedSAL6020_R01DetailList, removeDeletedSAL6020_R01DetailList, 
		selectedSAL6020_R01DetailList, setSelectedSAL6020_R01DetailList, addSelectedSAL6020_R01DetailList, removeSelectedSAL6020_R01DetailList,
		SAL6020_R01DetailList, setSAL6020_R01DetailList, insertSAL6020_R01DetailList,
		originalSAL6020_R01DetailList, setOriginalSAL6020_R01DetailList,
		allCount, setAllCount,
		initData,
		setScrollTop, setDetailScrollTop,
	} = useSAL6020_R01Store();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { printPdfFromBlob } = useQzPrint();

	useFetchActionbarAuth("SAL6020_R01");

	const handlePrintClick = useCallback(async () => {
		if (!selectedSAL6020_R01?.salesEstimateNo) {
			showWarning("출력할 견적번호를 선택해주세요");
			return;
		}
		setLoadingSpinner(true);
		try {
			const blob = await getPdfBlob_SAL6020_R01(selectedSAL6020_R01.salesEstimateNo);
			if (qz.websocket.isActive()) {
				const ok = await printPdfFromBlob(blob, "report1");
				if (ok) {
					showSuccess("PDF 출력을 완료하였습니다.");
				} else {
					const fileURL = URL.createObjectURL(blob);
					const win = window.open(fileURL, "_blank");
					if (win) win.addEventListener("load", () => win.print());
					showWarning("QZ로 출력할 수 없어 브라우저 인쇄 창을 띄웁니다.");
				}
			} else {
				const fileURL = URL.createObjectURL(blob);
				window.open(fileURL, "_blank");
				showSuccess("PDF를 새 탭에서 열었습니다.");
			}
		} catch (error) {
			console.error("Print error:", error);
			showError("PDF 출력 중 오류가 발생했습니다.");
		} finally {
			setLoadingSpinner(false);
		}
	}, [selectedSAL6020_R01, printPdfFromBlob, setLoadingSpinner]);
	

	const handleExcelClick = useCallback(async () => {
		if (!selectedSAL6020_R01) {
			showWarning("선택된 매출역이 없습니다.");
			return;
		}
		setLoadingSpinner(true);

		const { isDefaultFilter, isDefaultPastFilter, listLength } = fetchFilterConfig(
			SAL6020_R01Filter,
			SAL6020_R01PastFilter,
			defaultSAL6020_R01Filter,
			SAL6020_R01List.length
		);

		if (!selectedSAL6020_R01?.salBillNo) {
			showWarning('매출번호가 선택되지 않았습니다.');
			setLoadingSpinner(false);
			return;
		}
		const response = await downloadExcel_SAL6020_R01(selectedSAL6020_R01.salesEstimateNo);

		downloadSettingExcel({ responseData: response.data.data, fileName: '견적서 출력-excel.xlsx' });

		setLoadingSpinner(false);
	}, [selectedSAL6020_R01])

	const getParams = (filter: SAL6020_R01Filter) => {
		const params: Partial<SAL6020_R01Filter> = {
			compCd: filter.compCd || undefined,
			dateRange: filter.dateRange || undefined,
			custInput: filter.custInput || undefined,
		};
		return params;
	}

	const renewalAllCount = useCallback(async () => {
		const response = await getSAL6020_R01AllCount(getParams(SAL6020_R01Filter));
		setAllCount(response.data.data);
		return response.data.data;
	}, [SAL6020_R01Filter, setAllCount]);

	const fetchData = useCallback(async () => {
		setScrollTop(null);
		setDetailScrollTop(null);
		setLoadingSpinner(true);

		const {isDefaultFilter, isDefaultPastFilter, listLength} = fetchFilterConfig(
			SAL6020_R01Filter,
			SAL6020_R01PastFilter,
			defaultSAL6020_R01Filter,
			SAL6020_R01List.length
		);
	
		const responseData = (await getSAL6020_R01List(
			isDefaultFilter? '' : 'search',
			getParams(SAL6020_R01Filter),
			listLength
		));


		let newList = [...SAL6020_R01List ]
		newList = fetchDataSetHandler( //newList ?�용??DtoList???�록
			isDefaultFilter, isDefaultPastFilter,
			responseData.data.data,
			SAL6020_R01List, setSAL6020_R01List,
		);

		const processAllCount = await renewalAllCount();
		if (newList && newList.length > 0) {
			gridRefSelectedRowHandler(
				gridRef,
				setSelectedSAL6020_R01,
				() => true,// () => !responseData.find(value => value.salBillNo === selectedSAL6020_R01?.salBillNo)
			);
			setSAL6020_R01PastFilter(SAL6020_R01Filter);
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총${newList.length}/${processAllCount}건)`);
			setTimeout(() => setMessage(""), 5000);
		}else {
			showWarning('데이터가 없습니다.');
			setSelectedSAL6020_R01(undefined);
			setSAL6020_R01List([]);
			setSAL6020_R01DetailList([]); 
			setDeletedSAL6020_R01DetailList([]);
			setSelectedSAL6020_R01DetailList([]);
			setOriginalSAL6020_R01DetailList([]);
		}
		setLoadingSpinner(false);
		return responseData;
	}, [SAL6020_R01Filter, SAL6020_R01List, setSAL6020_R01List, setSAL6020_R01PastFilter, setSelectedSAL6020_R01, selectedSAL6020_R01, setScrollTop, setDetailScrollTop])
	

	const fetchDetailList = useCallback(async () => {
		if (!selectedSAL6020_R01?.salesEstimateNo) {
			setDetailFetchTrigger(false);
			return;
		}

		setDetailScrollTop(null);
		try {
			const response = await getSAL6020_R01DetailList(selectedSAL6020_R01.salesEstimateNo);
			
			if (response.data.successFlag && response.data.data) {
				const responseData = response.data.data;
				
				if(responseData && responseData.length > 0){
					const processedData = responseData.map((value, idx) => ({
						...value,
						valueIndex: value.valueIndex ?? idx + 1,
						orderIndex: value.orderIndex ?? idx + 1,
						orderIndexSeq: value.orderIndexSeq ?? 0,
						// 서버 값 → 화면 편집 필드 동기화
						estimatePrice: (value as any).estimatePrice ?? (value as any).itemPrice ?? 0,
						estimateQty: (value as any).estimateQty ?? (value as any).itemQty ?? 0,
						estimateUnit: (value as any).estimateUnit ?? (value as any).unit ?? '',
						itemAmt: (value as any).itemAmt ?? (((Number((value as any).estimateQty ?? (value as any).itemQty ?? 0)) * Number((value as any).estimatePrice ?? (value as any).itemPrice ?? 0)) - Number((value as any).dcAmt ?? 0)),
						// 호환 필드 유지
						itemCost: (value as any).itemPrice,
						id: (value as any).id
					}));
					
					setSAL6020_R01DetailList(processedData);
					setOriginalSAL6020_R01DetailList(responseData);
					setMessage(`${selectedSAL6020_R01?.customNm}의 상세내역 ${responseData.length}건을 조회하였습니다.`);
					setTimeout(() => setMessage(""), 5000);
				} else {
					// 데이터가 없는 경우 기본 행 추가
					setSAL6020_R01DetailList([]);
					insertSAL6020_R01DetailList([{ ...defaultSAL6020_R01DetailDto, inserted: true }]);
					setMessage("상세내역이 없습니다. 새로 추가할 수 있습니다.");
					setTimeout(() => setMessage(""), 3000);
				}
			} else {
				// API 응답 실패 처리
				showError('상세내역 조회에 실패했습니다.');
				setSAL6020_R01DetailList([]);
				insertSAL6020_R01DetailList([{ ...defaultSAL6020_R01DetailDto, inserted: true }]);
			}
		} catch (error) {
			console.error('상세내역 조회 오류:', error);
			showError('상세내역 조회 중 오류가 발생했습니다.');
			setSAL6020_R01DetailList([]);
			insertSAL6020_R01DetailList([{ ...defaultSAL6020_R01DetailDto, inserted: true }]);
		} finally {
			// 트리거 초기화 (중요!)
			setDetailFetchTrigger(false);
		}
	}, [
		selectedSAL6020_R01?.salesEstimateNo,
		selectedSAL6020_R01?.customNm,
		setSAL6020_R01DetailList,
		setOriginalSAL6020_R01DetailList,
		insertSAL6020_R01DetailList,
		setMessage,
		setDetailScrollTop,
	]);

	// 헤더 선택 시 트리거 설정
	useEffect(() => {
		if (selectedSAL6020_R01?.salesEstimateNo) {
			setDetailFetchTrigger(true);
		}
	}, [selectedSAL6020_R01?.salesEstimateNo]);
	
	// 트리거 발동 시 조회 실행
	useEffect(() => {
		if (detailFetchTrigger) {
			fetchDetailList();
		}
	}, [detailFetchTrigger, fetchDetailList]);

	// 빈 행 보장 로직 (기존 유지)
	useEffect(() => {
		if (selectedSAL6020_R01 && SAL6020_R01DetailList.length === 0) {
			insertSAL6020_R01DetailList([{ ...defaultSAL6020_R01DetailDto, inserted: true }])
		}
	}, [selectedSAL6020_R01, SAL6020_R01DetailList, insertSAL6020_R01DetailList])
	
	return {
		handlePrintClick,
		handleExcelClick,
		fetchData,
	};
}
